import React from 'react';
import styles from './index.module.scss';
import { useIntl } from 'react-intl';

const { footer } = styles;

const Footer = () => {
  const intl = useIntl();
  return (
    <div className={footer}>
      <span>ACCIONA © 2025. {intl.formatMessage({ id: 'footer' })}</span>
    </div>
  );
};

export default Footer;
